module.exports = new Promise(resolve => {
                    const env = window.location.hostname.toLowerCase().split( '.' ).find( function ( chunk ) {
                        return [ 'qa', 'pprd', 'localhost' ].indexOf( chunk ) >= 0;
                    } );

                    const getURL = ( url ) => {
                        if(env === 'localhost') {
                            return 'http://localhost:3001/moduleEntry.js'
                        } else {
                            return url.replace( '(env.)', env ? env + '.' : '' );
                        }
                    }

                    const remoteUrl = getURL('https://(env.)learn-components.biw.cloud/moduleEntry.js')
                    const script = document.createElement('script')
                    script.src = remoteUrl
                
                    script.onload = () => {
                      const proxy = {
                        get: (request) => window.Remote.get(request),
                        init: (arg) => {
                          try {
                            return window.Remote.init(arg)
                          } catch(e) {
                            console.log('remote container already initialized')
                          }
                        }
                      }
                      resolve(proxy)
                    }
                    document.head.appendChild(script);
                  })
                  ;